import { dayOf, type FitView } from "@/lib/posting";
import { FitBar, FitLine } from "./parts";

/** Beside a sent application: the fit of the baseline when it matched. */
export default function FitAtMatchCard({
    fit,
    scoredAt,
}: {
    fit: FitView;
    scoredAt: string | undefined;
}) {
    return (
        <section className="flex flex-col gap-2.5 rounded-card border border-line bg-card px-5 py-[18px] shadow-card">
            <h2 className="m-0 font-display text-card-title font-bold tracking-[-0.01em]">
                Fit at match time
            </h2>
            <FitLine covered={fit.covered} asked={fit.asked}>
                keywords your baseline said, scored when it matched
                {scoredAt ? ` on ${dayOf(scoredAt)}` : ""}. Nothing scores the tailored resume.
            </FitLine>
            <FitBar share={fit.share} height={8} />
        </section>
    );
}
